import { UserEntityInterface } from '@types';
import { FeaturePermission, PagePermission, PermissionActions } from '@enums';

export const userHasPermissions = (
  currentUser: UserEntityInterface,
  page: PagePermission,
  features: FeaturePermission[],
  actions: PermissionActions[]
) => {
  const roles = currentUser?.roles?.length ? currentUser?.roles : currentUser?.unit?.roles || [];

  return features?.every((feature) =>
    roles?.some((role) =>
      role?.pagePermissions.some(
        (pp) =>
          pp.name === page &&
          pp.featurePermissions.some(
            (f) => f.name === feature && actions.every((action) => f[action])
          )
      )
    )
  );
};
